import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AppRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check user role and redirect
    // For now, default to owner
    navigate('/owner');
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">Loading...</h2>
      </div>
    </div>
  );
}
